import axios from 'axios';
import Vue from 'vue';
import {getNswSchoolSafetyApiUrl, getConfig} from '../../utils/config';

const fetchSchools = () => {
  const url = getNswSchoolSafetyApiUrl() + '/schools';
  return axios.get(url,
    {
      headers: Vue.prototype.$OAuth.buildHttpHeader({
        "adfs":"true"
      })
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      // eslint-disable-next-line
      console.error(err);
      throw err;
    });
};

const updateSchoolStatuses = (schoolCodes, date, nonOperationalFlag) => {
  const url = getNswSchoolSafetyApiUrl() + '/schools';
  const body = {
    "codes": schoolCodes,
    "operationalDate": date,
    "nonOperational": nonOperationalFlag
  };
  const headers = Vue.prototype.$OAuth.buildHttpHeader({
    "api-secret": getConfig("VUE_APP_API_SECRET"),
    "api-key":getConfig("VUE_APP_API_KEY"),
    "adfs":"true"
    }
  );
  return axios.post(url, body, {
    headers: headers
  });
};

export default { fetchSchools, updateSchoolStatuses };
